// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
tr.unread {
    background-color: #c4e2ff !important;
}

tr.read-notification td {
    color: #888888;
}

table.notificationList thead tr th {
    width: 10ch;
    white-space: nowrap;
}

table.notificationList tbody tr td {
    width: 10ch;
    white-space: nowrap;
}

table.notificationList thead tr th.message {
    width: 100%;
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

table.notificationList tbody tr td.message {
    width: 100%;
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/XSifterNotificationList.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["\r\ntr.unread {\r\n    background-color: #c4e2ff !important;\r\n}\r\n\r\ntr.read-notification td {\r\n    color: #888888;\r\n}\r\n\r\ntable.notificationList thead tr th {\r\n    width: 10ch;\r\n    white-space: nowrap;\r\n}\r\n\r\ntable.notificationList tbody tr td {\r\n    width: 10ch;\r\n    white-space: nowrap;\r\n}\r\n\r\ntable.notificationList thead tr th.message {\r\n    width: 100%;\r\n    max-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\ntable.notificationList tbody tr td.message {\r\n    width: 100%;\r\n    max-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
